import React, { useEffect } from "react";
import { usePrivacyPolicy } from "../../hooks/usePrivacyPolicy";
import loaderGif from "../../assets/learnlocalLoader.gif";
import policyNotFound from "../../assets/privacypolicy-not-found.gif";

const PrivacyPolicy = ({ isOpen, onClose }) => {
  const { data, loading, error, fetchPrivacyPolicy } = usePrivacyPolicy();

  useEffect(() => {
    if (isOpen && !data) {
      fetchPrivacyPolicy({ heading: "Privacy Policy" });
    }
  }, [isOpen, data, fetchPrivacyPolicy]);

  return (
    <div
      className={`fixed inset-0 z-50 bg-black bg-opacity-30 transition-opacity duration-300 ${
        isOpen ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
      onClick={onClose}
    >
      <div
        className={`fixed top-0 right-0 h-full w-4/5 sm:w-1/2 md:w-1/3 lg:w-[465px] overflow-y-auto bg-white p-4 md:p-10 shadow-lg transition-transform duration-300 ease-in-out transform ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-2xl text-gray-600 hover:text-black"
        >
          &times;
        </button>

        {/* Privacy Policy Content */}
        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-black mb-4">Privacy Policy</h2>

          {loading && (
            <div className="flex flex-col items-center justify-center py-20">
              <img src={loaderGif} alt="Loading" className="w-20 h-20" />
              <p className="text-gray-500 mt-2">Loading Privacy Policy...</p>
            </div>
          )}

          {error && (
            <div className="text-gray-500 mt-4">
              <div className="w-full flex flex-col items-center justify-center pt-4">
                <div className="w-24 h-24">
                  <img
                    src={policyNotFound}
                    alt="Error"
                    className="max-width-full h-auto"
                  />
                </div>
                <h3 className="font-semibold text-lg text-red-500">
                  Error Loading Privacy Policy
                </h3>
              </div>
            </div>
          )}

          {!loading && !error && data && (
            <div
              className="privacy-content"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          )}

          {!loading && !error && !data && (
            <div className="text-gray-500 mt-4">
              <div className="w-full flex flex-col items-center justify-center pt-4">
                <div className="w-24 h-24">
                  <img
                    src={policyNotFound}
                    alt="Not Found"
                    className="max-width-full h-auto"
                  />
                </div>
                <h3 className="font-semibold text-lg text-blackie">
                  Privacy Policy Not Found
                </h3>
                <p className="text-gray-600 text-sm mt-2 text-center">
                  Looks like the privacy policy is not available right now.
                  Please check back later.
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
